import React from 'react';
import './Contact.css';

const Contact = () => {
  

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Ready to start your project? Contact us today for a free consultation
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card unified">
              <div className="info-section">
                <div className="info-icon">📍</div>
                <div className="info-details">
                  <h4>Visit Us</h4>
                  <p>KB Aman Ali Road, Boromia Mosjid<br />Chawk Bazar, Chattagram, Bangladesh</p>
                </div>
              </div>

              <div className="info-section">
                <div className="info-icon">📞</div>
                <div className="info-details">
                  <h4>Call Us</h4>
                  <p>
                    <a href="tel:+8801818456866">01818-456866</a>
                    {' | '}
                    <a href="tel:+8801618456866">01618-456866</a>
                  </p>
                </div>
              </div>

              <div className="info-section">
                <div className="info-icon">✉️</div>
                <div className="info-details">
                  <h4>Email Us</h4>
                  <p><a href="mailto:jaforjarif@gmail.com">jaforjarif@gmail.com</a></p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="map-card">
            <h3 className="map-title">Our Location</h3>
            <div className="map-container">
              <iframe
                title="Alvi Construction Location"
                src="https://maps.google.com/maps?q=22.358240,91.845047&z=16&output=embed"
                width="100%"
                height="420"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
